let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("1VRB2"), load("bABhq"), load("6prS0")]).then(() => parcelRequire('ben1W'));